/***
 *
 *   CHECKBOX STYLES
 *   The reference uses native checkboxes tinted with the CSS accent-color
 *   (`h-4 w-4 accent-primary-600`) rather than a background-image tick, so
 *   they inherit the platform's own checked rendering and stay crisp at any
 *   zoom. That replaces the 24px box with the white SVG check.
 *
 **********/

const Style = {
    input: `mr-2 mt-0.5 h-4 w-4 shrink-0 cursor-pointer rounded border-border accent-primary-600
    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring`,
    label: 'mt-px cursor-pointer text-sm font-normal normal-case text-text-primary',
};

export default Style;
